// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--3hAzY","info_page":"layout-module--info_page--3r_Kf","content":"layout-module--content--1Y4HW"};